import axios from "axios";

const API_ROOT = "https://lse-f.com/";

/**
 * サーバーリクエスト
 * @param {*} endpoint 
 * @param {*} data 入力データ
 * @returns 
 */
function callPostApi(endpoint, data) {
  console.log("callPostApi axios data:", data);

  // //ドメインの有無を確認
  // const fullUrl =
  //   endpoint.indexOf(API_ROOT) === -1 ? API_ROOT + endpoint : endpoint;
  //   console.log(fullUrl)
  const fullUrl = API_ROOT + endpoint;

  return axios
    .post(fullUrl, data)
    .then(response => {
      const result = response;
      console.log("axios response=", response);
      return  result ; //返して代入する変数名と合わせる
    })
    .then(response => { 
      console.log(response);
    })
    .catch(err => {
      console.log("axios err", err); 
      alert("一度[戻る]ボタンにて戻って頂き、やり直してください。")
      return null ;
    });
}

export const fetchPosts = data => callPostApi(`mail/sendmail`, data);
